export function getOptimalDestinationQueryParams(
    selectedIds: string[],
    availableIds: string[],
): { destinationStepIds?: string[]; excludedDestinationStepIds?: string[] } {
    if (selectedIds.length === 0 || selectedIds.length === availableIds.length) {
        return {};
    }
    const excludedIds = availableIds.filter((id) => !selectedIds.includes(id));
    if (excludedIds.length < selectedIds.length) {
        return { excludedDestinationStepIds: excludedIds };
    }
    return { destinationStepIds: selectedIds };
}
